import { toast as rhtToast } from 'react-hot-toast/headless';

import type { Message, ToastOptions } from './toast.types';

const toast = (message: Message, options: ToastOptions = {}): string => {
  const id = rhtToast.custom(message, options);
  return id;
};

toast.dismiss = rhtToast.dismiss;

export { toast };
